export default "__VITE_ASSET__BJiaDsUd__"